import React, {useEffect, useState} from 'react';
import services from 'services';
import LoadingPage from 'components/generic/LoadingPage';
import App from './App';
import {initialize} from 'modules/common/actions';

export default function AppBootstrapper() {
	const [ready, setReady] = useState(false);

	useEffect(() => {
		let mounted = true;
		// Wait for all critical services
		Promise.all([
			services.waitFor('api'),
			// add more if needed: services.waitFor('intl'), etc.
		]).then(() => {
			if (mounted) {
				// Dispatch initialize to populate Redux state with user/org data
				const store = services.get('store');
				store.dispatch(initialize());
				setReady(true);
			}
		});
		return () => {
			mounted = false;
		};
	}, []);

	if (!ready) return <LoadingPage />;
	return <App />;
}
